var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCargo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.378,
    height: 19.421,
    viewBox: "0 0 19.378 19.421",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#000;stroke-miterlimit:10;stroke-width:1.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.75 0.819)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M63.967,69.64l4.7,2.16,4.359-1.883L77.3,71.9l4.545-2.135v-6L77.1,61.852V56.039l-4.126-1.912L68.71,55.89v5.843l-4.743,2.074Z",
    transform: "translate(-63.967 -54.127)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M194.7,102.6l4.774,2.25,4.617-2.084",
    transform: "translate(-190.399 -100.639)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x2: 0.16,
    y2: 12.98,
    transform: "translate(9.119 2.409)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M83.784,265.683l-9.391,4.251-5.084-2.112",
    transform: "translate(-69.092 -258.197)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M195.665,263.629l9.669,4.192v7.115",
    transform: "translate(-191.358 -257.113)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 5.029,
    y2: 1.737,
    transform: "translate(12.971 9.693)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 0.111,
    y1: 6.896,
    transform: "translate(4.643 10.927)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 0.111,
    y2: 6.362,
    transform: "translate(0.217 8.906)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCargo);
export default __webpack_public_path__ + "static/media/Cargo.bcbf7f5046bc6bed11b878e1ef7efa21.svg";
export { ForwardRef as ReactComponent };